import { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Home from './Components/Home/Home';
import { useLocation } from "react-router-dom";
import Aboutus from './Components/Aboutus/Aboutus';
import Navbar from './Components/Navbar/Navbar';
import Footer from './Components/Footer/Footer';
import Tour from './Components/Tour/Tour';
import Destination from './Components/Destination/Destination';
import Contact from './Components/Contact/Contact';
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant'  
    });
  }, [pathname]);

  return null;
}
function App() {
  return (
    <Router>
    <Navbar/>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/aboutus" element={<Aboutus />} />
         <Route path="/tour" element={<Tour />} />
           <Route path="/destination" element={<Destination />} />
            <Route path="/contactus" element={<Contact />} />
      </Routes>
      <Footer/>
    </Router>
  );
}

export default App;
